import * as React from 'react';
import { Box, Button, CircularProgress, Grid, TextField, Tooltip } from '@mui/material';
import { Add, AutoFixHigh } from '@mui/icons-material';

import { useZoneServiceItemsFormManager } from './zone-service-form.hook';

interface ZoneServiceItemsFormProps {
  zoneId: number;
  categoryId?: number | null;
  next?: (data?: any) => void;
}

export const ZoneServiceItemsForm = ({ zoneId, categoryId, next }: ZoneServiceItemsFormProps) => {
  const [{ formManager, loading, applyingDefaults, applyDefaultsFromCategory }] = useZoneServiceItemsFormManager({
    zoneId,
    categoryId,
    next,
  });

  return (
    <Box sx={{ paddingY: 2 }}>
      <form onSubmit={formManager.handleSubmit}>
        <Grid container sx={{ alignItems: 'center' }} spacing={2}>
          <Grid item xs={10}>
            <TextField
              label="Service item"
              placeholder="Input service name..."
              variant="outlined"
              fullWidth
              onChange={formManager.handleChange('name')}
              error={!!(formManager.errors.name && formManager.touched.name)}
              helperText={formManager.touched.name ? formManager.errors.name : null}
              value={formManager.values.name || ''}
            />
          </Grid>

          <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Button
              type="submit"
              startIcon={loading ? <CircularProgress color="inherit" size={16} sx={{ marginRight: 0.5 }} /> : <Add />}
              sx={{ paddingX: 2 }}
              disabled={loading}
            >
              Add
            </Button>
          </Grid>
        </Grid>
      </form>

      {categoryId && (
        <Box sx={{ mt: 1.5 }}>
          <Tooltip title="Copy all default service items from this zone's category">
            <span>
              <Button
                variant="outlined"
                size="small"
                startIcon={
                  applyingDefaults ? <CircularProgress color="inherit" size={14} /> : <AutoFixHigh fontSize="small" />
                }
                onClick={applyDefaultsFromCategory}
                disabled={applyingDefaults}
                fullWidth
              >
                Apply category defaults
              </Button>
            </span>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};
